import { ValidationMessageResolver } from '@ngx-strakit/validation';
import { TranslateService } from '@ngx-translate/core';
import { inject, Injectable } from '@angular/core';
import { URL_VALIDATOR_NAME } from '../../validators/url.validator';

@Injectable()
export class SkUrlValidationMessageResolver implements ValidationMessageResolver {
  private readonly translate = inject(TranslateService);
  readonly errorCode = URL_VALIDATOR_NAME;

  getMessage(): string {
    return this.translate.instant('label.validation.url');
  }
}
